import { ACCESS_TOKEN_KEY } from '@/constants/token.constant';
import token from '@/lib/token';
import { decode } from 'jwt-js-decode';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { getMyData } from '@/repositories/users/usersRepository';

const useIsLoginContext = () => {
  const [isLogin, setIsLogin] = useState(!!token.getToken(ACCESS_TOKEN_KEY));
  const [userData, setUserData] = useState({isAdmin: false, isOwner: false, isImposter: false, userID: 0, organisationID: 0});
  const [userFilter, setUserFilter] = useState({ownerFilter: null});
  const [currentExpireDate, setExpireDate] = useState(null);
  const [tokenVariable, setToken] = useState(token.getToken(ACCESS_TOKEN_KEY));

  useEffect(() => {
    let item = localStorage.getItem("MICAST_USER_FILTER")
    console.info("initialize micast_user_filter:", item);

    if (item) {
      let parsedItem = JSON.parse(item);
      if (parsedItem) {
        setUserFilter(parsedItem);
      }
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("MICAST_USER_FILTER", JSON.stringify(userFilter));
  }, [userFilter]);

  useEffect(() => {
    if (tokenVariable && tokenVariable !== "undefined") {
      var decoded_token = decode(tokenVariable).payload;
      if (decoded_token && decoded_token.exp) {
        var tokenExpiration = decoded_token.exp;
        console.info(decoded_token);
        let expireDate = moment.unix(tokenExpiration);
        setExpireDate(expireDate.toString());
        if (expireDate.diff(moment(Date.now())) < 0) {
          console.info ("LOGGGED OUT TOKEN EXPIRED");
          setToken(null);
        } else {
          setIsLogin(true);
          console.info("SET USERDATA");
          setUserData({isAdmin: decoded_token.IsAdmin , userID: decoded_token.UserID, isLogin: true})

          getMyData().then((response) => {
            const data = response.data;
            if (data?.user?.id) {
              setUserData(prev => ({
                ...prev,
                isAdmin : data.isAdmin,
                isOwner: data.isOwner,
                isImposter: data.isImposter,
                organisationID: data.user.organisation_id,
                userID: data.user.id
              }));
            } else {
              console.warn("error -- no user data returned from server");
            }
          }).catch((error) => {
            console.info("error - get mydata: ", error);
          });
        }
      }
    } else {
      setIsLogin(false);
    }

  }, [isLogin, tokenVariable]);

  return {
    isLogin,
    setIsLogin,
    isAdmin: userData.isAdmin,
    isOwner: userData.isOwner,
    isImposter: userData.isImposter,
    userID: userData.userID,
    organisationID: userData.organisationID,
    setUserData,
    expireDate: currentExpireDate,
    setToken,
    token: tokenVariable,
    userFilter,
    setUserFilter,
  };
};

export default useIsLoginContext;
